import { c as _c } from "react/compiler-runtime";
import { FALLBACK_APP_URL } from '@morpho-org/dapp-core';
import { useDialogContext } from '@morpho-org/ui-v6/contexts';
import { Button } from '@repo/ui';
import { Close } from '@repo/ui/icons';
import { memo, useCallback } from 'react';
import { ButtonLink } from '@/components/common/ButtonLink';
import { clientEnvs } from '@/config/client-envs';
import { useServiceUnavailable } from '@/contexts/ServiceUnavailable/ServiceUnavailable.context';
const ServiceUnavailableDialog = () => {
  const $ = _c(11);
  const {
    toggleDialog
  } = useDialogContext();
  const {
    closeServiceUnavailableDialog
  } = useServiceUnavailable();
  let t0;
  if ($[0] !== closeServiceUnavailableDialog || $[1] !== toggleDialog) {
    t0 = () => {
      toggleDialog(false);
      closeServiceUnavailableDialog();
    };
    $[0] = closeServiceUnavailableDialog;
    $[1] = toggleDialog;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const close = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Close />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== close) {
    t2 = <Button size="icon" onClick={close} variant="secondary" className="top-md right-md absolute" aria-label="Close">{t1}</Button>;
    $[4] = close;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="gap-sm flex flex-col items-center px-[40px]"><span className="text-title-xs text-center">Something went wrong.</span><span className="text-secondary-foreground text-center text-xs">This could be due to connectivity or other local issues. Try refreshing the app or managing your positions through the Morpho Fallback App.</span></div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ButtonLink className="max-md:w-full" mode="external" href={FALLBACK_APP_URL} buttonProps={{
      size: "default",
      label: "Use Fallback App",
      style: {
        width: "100%"
      }
    }} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="gap-sm flex flex-wrap items-center justify-center">{t4}<ButtonLink className="max-md:w-full" mode="external" href={clientEnvs.NEXT_PUBLIC_STATUS_URL} buttonProps={{
        size: "default",
        variant: "secondary",
        label: "Check App Status",
        style: {
          width: "100%"
        }
      }} /></div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2) {
    t6 = <div className="gap-lg flex flex-col items-center">{t2}{t3}{t5}</div>;
    $[9] = t2;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default memo(ServiceUnavailableDialog);